import axios, {AxiosResponse} from 'axios';

export const addPushToken = (token: string): Promise<AxiosResponse<{value: boolean}>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/push/add`,
    {typeOs: 'WEB', pushToken: token}
  );
};
